import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationFolderBookDb = {
  userId: string;
  folderId: string;
  bookId: string;
  order: number;
}
const initial: RelationFolderBookDb = {
  userId: '',
  folderId: '',
  bookId: '',
  order: 0
};

export type RelationFolderBookDbHashType = {
  [key in string]: RelationFolderBookDb;
}

export type RelationFolderBookAddPayload = {
  id?: string;
} & RelationFolderBookDb;
export type RelationFolderBookUpdatePayload = {
  id: string;
} & { [P in keyof RelationFolderBookDb]?: RelationFolderBookDb[P] };

export type RelationFolderBookDbState = {
  relationFolderBooks: RelationFolderBookDbHashType;
}

export const  generateRelationFolderBookId = () : string =>  generateId('rfb');
let initialState: RelationFolderBookDbState = { relationFolderBooks: {} };
const key = 'relationFolderBooks';

const relationFolderBookDbSlice = createSlice({
  name: 'relationFolderBookDb',
  initialState,
  reducers: {
    initializeRelationFolderBooks(state: RelationFolderBookDbState) {
      state.relationFolderBooks = {};
    },
    addRelationFolderBook(state: RelationFolderBookDbState, action: PayloadAction<RelationFolderBookAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationFolderBookId();
      state.relationFolderBooks[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationFolderBook(state: RelationFolderBookDbState, action: PayloadAction<RelationFolderBookUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationFolderBooks[id] === undefined) {
        console.log(`*** RelationFolderBook not found: ${id}`);
      } else {
        const newData = { ...state.relationFolderBooks[id], ...obj };
        state.relationFolderBooks[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationFolderBook(state: RelationFolderBookDbState, action: PayloadAction<RelationFolderBookUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationFolderBooks[id];
      deleteData(key, id);
    },
    saveRelationFolderBooks(state: RelationFolderBookDbState) {
      saveAllData(key, state.relationFolderBooks);
    },
    signUpRelationFolderBooks(state: RelationFolderBookDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationFolderBooks, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationFolderBookDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationFolderBooks = updatedValues;
      if (changed) saveAllData(key, state.relationFolderBooks);
    })
  }
})

export const { initializeRelationFolderBooks, addRelationFolderBook, updateRelationFolderBook, deleteRelationFolderBook, saveRelationFolderBooks, signUpRelationFolderBooks } = relationFolderBookDbSlice.actions;
export default relationFolderBookDbSlice.reducer;
